import request from '@/utils/request'

const baseUrl = '/erp/sales/order'

export function pageSalesOrder (query) {
  return request({
    url: baseUrl + '/page',
    method: 'get',
    params: query
  })
}

export function getSalesOrder (id) {
  return request({
    url: baseUrl + '/detail',
    method: 'get',
    params: { id }
  })
}

export function guidePriceOptions (skuId, warehouseId) {
  return request({
    url: baseUrl + '/guide-price-options',
    method: 'get',
    params: { skuId, warehouseId }
  })
}

export function skuOptions (keyword, warehouseId) {
  return request({
    url: baseUrl + '/sku-options',
    method: 'get',
    params: { keyword, warehouseId }
  })
}

export function createSalesOrder (data) {
  return request({
    url: baseUrl + '/add',
    method: 'post',
    data
  })
}

export function updateSalesOrder (data) {
  return request({
    url: baseUrl + '/edit',
    method: 'post',
    data
  })
}

export function auditSalesOrder (id) {
  return request({
    url: baseUrl + '/audit',
    method: 'post',
    data: { id }
  })
}

export function reverseAuditSalesOrder (id) {
  return request({
    url: baseUrl + '/reverse-audit',
    method: 'post',
    data: { id }
  })
}

export function voidWholeSalesOrder (id) {
  return request({
    url: baseUrl + '/void',
    method: 'post',
    data: { id }
  })
}

export function deleteSalesOrder (id) {
  return request({
    url: baseUrl + '/delete',
    method: 'post',
    data: { id }
  })
}
